// extracted by mini-css-extract-plugin
export default {"providersSection":"GTueJlg8EDyhfcS4lqdp","mainTitle":"u7EcfeZChp3AEtEyfmG3","swiper":"KNqBd0iVzHzFSFx3Y8dC","swiperSlide":"zkawh3gdbj8gnH_xRx1B","slideContent":"hQTWpek2pqPaCb65HeMF","slideImage":"XPm6ROdO5yAhU0yva9UR"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"providersSection\":\"GTueJlg8EDyhfcS4lqdp\",\"mainTitle\":\"u7EcfeZChp3AEtEyfmG3\",\"swiper\":\"KNqBd0iVzHzFSFx3Y8dC\",\"swiperSlide\":\"zkawh3gdbj8gnH_xRx1B\",\"slideContent\":\"hQTWpek2pqPaCb65HeMF\",\"slideImage\":\"XPm6ROdO5yAhU0yva9UR\"}";
        // 1755964983637
        var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  